import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectAllEntities} from '@ngneat/elf-entities';

import {issueKindsStore} from '@store/settings/issueKinds/issueKinds.store';

export const getIssueKindDataSource = createRequestDataSource({
    store: issueKindsStore,
    data$: () => issueKindsStore.pipe(
        selectAllEntities(),
    ),
    requestKey: 'getIssueKinds',
    dataKey: 'issueKinds',
});